import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsMobileFilterPage.module.scss";
import {SongsMobileFilterHeader} from "./modules/mobile-filter-header/SongsMobileFilterHeader";
import {SongsMobileFilterPanel} from "./components/mobile-filter-panel/SongsMobileFilterPanel";
import {SongsMobileFilterActions} from "./modules/mobile-filter-actions/SongsMobileFilterActions";

export const SongsMobileFilterPage: VoidFunctionComponent = () => {
  return (
    <div className={s.container}>
      <SongsMobileFilterHeader />
      <SongsMobileFilterPanel />
      <SongsMobileFilterActions />
    </div>
  );
}
